var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02002 3.5C1.19102 3.5 0.515015 2.829 0.515015 2C0.515015 1.171 1.18201 0.5 2.01001 0.5H2.02002C2.84902 0.5 3.52002 1.171 3.52002 2C3.52002 2.829 2.84902 3.5 2.02002 3.5ZM3.52002 10C3.52002 9.171 2.84902 8.5 2.02002 8.5H2.01001C1.18201 8.5 0.515015 9.171 0.515015 10C0.515015 10.829 1.19102 11.5 2.02002 11.5C2.84902 11.5 3.52002 10.829 3.52002 10ZM3.52002 18C3.52002 17.171 2.84902 16.5 2.02002 16.5H2.01001C1.18201 16.5 0.515015 17.171 0.515015 18C0.515015 18.829 1.19102 19.5 2.02002 19.5C2.84902 19.5 3.52002 18.829 3.52002 18Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more-vertical.33dcc7bcec12032e3118835655401e47.svg";